import React, { useReducer } from 'react';
// import { recordIdentityEvent } from 'utilities/uTagging';
import { DocumentsModalScrollInfo } from '../documentsModal/DocumentsModalScrollInfo';

export const useScrollInfoModal = ({ onClickCancelButton }) => {
    const initialState = {
        scrollInfoModalShow: false,
        scrollInfoModalShowed: false,
    };
    const [{ scrollInfoModalShow, scrollInfoModalShowed }, dispatch] = useReducer((prev, next) => {
        return { ...prev, ...next };
    }, initialState);

    const handleClickCancelButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
        onClickCancelButton(e);
        // recordTagPrecontractualModalScrollInfo('salir');
    };
    const handleClickContinueButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
        // recordTagPrecontractualModalScrollInfo('entendido');
    };
    const handleClickCloseButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
        // recordTagPrecontractualModalScrollInfo('cerrar');
    };

    const handleClickGif = e => {
        e.preventDefault();
        // recordTagPrecontractualModalScrollInfo('click en gif');
    };

    const openScrollInfoModal = tagEvent => {
        // recordTagPrecontractualModalScrollInfo(tagEvent);
        dispatch({ scrollInfoModalShowed: true, scrollInfoModalShow: true });
    };

    const renderScrollInfoModal = () => {
        if (!scrollInfoModalShow) return null;

        return (
            <DocumentsModalScrollInfo
                handleClickCloseButton={handleClickCloseButtonModalScrollInfo}
                handleClickGif={handleClickGif}
                handleClickCancelButton={handleClickCancelButtonModalScrollInfo}
                handleClickContinueButton={handleClickContinueButtonModalScrollInfo}
            />
        );
    };

    return { scrollInfoModalShow, scrollInfoModalShowed, renderScrollInfoModal, openScrollInfoModal };
};
